module.exports = __webpack_public_path__ + "img/shareimg.7e4442dd.svg";